import PropTypes from 'prop-types';

export enum TagsInputSize {
  SMALL = 'small',
  MEDIUM = 'medium',
  LARGE = 'large',
}

export const TagsInputSizePropType = PropTypes.oneOf(['small', 'medium', 'large']);

export interface TagsInputValue {
  text: string;
  id: string;
}
